const partnerBrandingFields = `
  partnerArticleBranding {
    partner {
      ... on Partner {
        title
        uri
        partnerInformation {
          channelName
          partnerLogo {
            mediaItemUrl
          }
          partnerAccentColor
          partnerFollowCode
        }
      }
    }
  }
`;

export default partnerBrandingFields;
